import { useCallback, useEffect, useRef, useState } from 'react';
import { getSaleRoundingSettings } from '../api/settingsApi';
import { DEFAULT_SALE_ROUNDING_SETTINGS } from '../utils/saleRounding';

export default function useSaleRoundingSettings(branchId) {
  const [state, setState] = useState({ settings: DEFAULT_SALE_ROUNDING_SETTINGS, loading: Boolean(branchId), error: null });
  const requestId = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++requestId.current;
    if (!branchId) {
      setState({ settings: DEFAULT_SALE_ROUNDING_SETTINGS, loading: false, error: null });
      return DEFAULT_SALE_ROUNDING_SETTINGS;
    }
    setState({ settings: DEFAULT_SALE_ROUNDING_SETTINGS, loading: true, error: null });
    try {
      const response = await getSaleRoundingSettings(branchId);
      const settings = response?.effective || DEFAULT_SALE_ROUNDING_SETTINGS;
      if (current === requestId.current) setState({ settings, loading: false, error: null });
      return settings;
    } catch (error) {
      if (current === requestId.current) setState({ settings: DEFAULT_SALE_ROUNDING_SETTINGS, loading: false, error });
      return null;
    }
  }, [branchId]);
  useEffect(() => {
    refresh();
    return () => { requestId.current += 1; };
  }, [refresh]);
  return { ...state, refresh };
}
